export default {
  checkResponse(data) {
    try {
      return JSON.parse(data)
    } catch (e) {
      console.log('Response is not JSON')
    }
  },

  getErrorText(e) {
    try {
      return e.response.data.Error
    } catch (ex) {
      return e
    }
  },

  getTradevineOAuthHeader(config, nonce) {
    return `OAuth oauth_consumer_key="${config.ConsumerKey}", oauth_signature_method="PLAINTEXT", oauth_version="1.0", oauth_signature="${
      config.ConsumerSecret
    }%26${config.TokenSecret}", oauth_token="${config.AccessToken}", oauth_nonce="${nonce}", oauth_timestamp="${Math.round(new Date().getTime() / 1000.0)}"`
  },

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  },
}
